import { SVGAttributes } from 'react'
import { IconName } from './Icon.types'
import iconSet from './iconset.json'
import { ExtendedIcon } from './Icon.utils'

type IconProps = SVGAttributes<SVGElement> & {
  iconName: IconName
  cascadeFillColor?: boolean
}

const Icon = ({ iconName, cascadeFillColor = false, ...other }: IconProps) => {
  const selectedIcon = iconSet.icons.find((icon) =>
    icon.properties.name.split(', ').includes(iconName)
  )

  const { height } = iconSet
  const width = selectedIcon?.icon.width || height

  const paths = selectedIcon?.icon.paths || []
  const fills = (
    selectedIcon?.attrs.map((attr) => ('fill' in attr ? attr.fill : undefined)) || []
  ).filter((fill): fill is string => !!fill)

  return (
    <ExtendedIcon
      paths={paths}
      fills={cascadeFillColor ? [] : fills}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden
      {...other}
    />
  )
}

export default Icon
